export default __webpack_public_path__ + "assets/quote.728d2738.svg";